module.exports = __webpack_public_path__ + "static/media/Elevation Piyush Ji.21eecbae.jpg";